import axios, {
  AxiosError,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from 'axios';
import {
  $LOCAL_REFRESH_TOKEN_KEY,
  $LOCAL_TOKEN_KEY,
} from '~/stores/useAuthStores';

export const apiBearerAI = ({ ...options }: AxiosRequestConfig) => {
  let authToken = localStorage.getItem($LOCAL_TOKEN_KEY);
  const refreshToken = localStorage.getItem($LOCAL_REFRESH_TOKEN_KEY);
  const baseURL =
    import.meta.env.NEXUS_API_AI_URL || 'https://api.nexushehub.com';
  const baseURLIAM =
    import.meta.env.NEXUS_API_IAM_URL || 'https://api.nexushehub.com';

  const instance = axios.create({
    baseURL,
    ...options,
  });

  instance.interceptors.request.use((config) => {
    if (authToken) {
      config.headers.set('Authorization', `Bearer ${authToken}`);
    }
    return config;
  });

  instance.interceptors.response.use(
    (config) => {
      return config;
    },
    async (error: AxiosError) => {
      const originalRequest = error.config as
        | (InternalAxiosRequestConfig & { _retry?: boolean })
        | undefined;
      if (
        (error?.response?.status === 401 ||
          (error.response?.data as { code?: number })?.code === 401) &&
        refreshToken &&
        originalRequest &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        try {
          const response = await axios.post(
            '/iam/user/v1/refresh-token',
            {
              refresh_token: refreshToken,
            },
            {
              baseURL: baseURLIAM,
            }
          );

          localStorage.setItem(
            $LOCAL_TOKEN_KEY,
            response?.data?.data?.access_token
          );
          localStorage.setItem(
            $LOCAL_REFRESH_TOKEN_KEY,
            response?.data?.data?.refresh_token
          );
          authToken = response?.data?.data?.access_token;
        } catch (err) {
          console.log(err);
          return Promise.reject(error);
        }
        return instance(originalRequest);
      }
      console.log(error);
      return Promise.reject(error);
    }
  );

  return instance;
};
